import React, { useMemo } from "react";
import Icon, {
    ICON_TYPE_ARROW_UP_DOWN,
    ICON_TYPE_ARROW_DOWN,
} from "../../Icon";
import { getClassNames } from "../../../utils";

function SortIcon({
    isSorted = false,
    direction = false,
    handleSort = () => {},
}) {
    const className = getClassNames(
        "table-cell__sorter-icon",
        isSorted && `table-cell__sorter-${direction}`
    );
    const iconType = useMemo(
        () => (isSorted ? ICON_TYPE_ARROW_DOWN : ICON_TYPE_ARROW_UP_DOWN),
        [isSorted]
    );

    return (
        <button
            type="button"
            className="table-cell__sorter"
            onClick={handleSort}
        >
            <Icon size={''} className={className} type={iconType} />
        </button>
    );
}


export default SortIcon;
